module.exports = __webpack_public_path__ + "a64552c4.png";